var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUltimateHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 15,
    viewBox: "0 0 77 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.1496,
    height: 14.2222,
    transform: "translate(0 0.659668)",
    fill: "#E9AB0C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 0.659735L3.55556 0.659668L4.18409 1.28821L1.77778 3.69452V11.847L4.18409 14.2534L3.55556 14.8819H2.40625L0 12.5834V2.95814L2.40625 0.659735Z",
    fill: "#E9AB0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85071 10.6331V3.41528H8.54315V10.0482L9.17782 10.6828H11.6169L12.2516 10.0482V3.41528H13.944V10.6331L12.4507 12.1264H8.34404L6.85071 10.6331Z",
    fill: "#FFBB0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5598 3.41528H18.2523V10.6953H22.6078V12.1264H16.5598V3.41528Z",
    fill: "#FFBB0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1365 4.84639H22.5356V3.41528H29.4298V4.84639H26.8289V12.1264H25.1365V4.84639Z",
    fill: "#FFBB0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4829 3.41528H33.1754V12.1264H31.4829V3.41528Z",
    fill: "#FFBB0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8555 3.41528H37.4235L40.0119 9.04017H40.0368L42.6377 3.41528H44.2057V12.1264H42.5755V6.82506H42.5506L40.5471 10.9068H39.5017L37.5106 6.82506H37.4857V12.1264H35.8555V3.41528Z",
    fill: "#FFBB0B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2554 3.41528H50.7986L53.9843 12.1264H52.267L51.5577 10.1975H48.4963L47.787 12.1264H46.0697L49.2554 3.41528ZM51.1843 8.80373L50.027 5.49351H50.0021L48.8821 8.80373H51.1843Z",
    fill: "#FFBB0B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7176 4.84639H54.1168V3.41528H61.011V4.84639H58.4101V12.1264H56.7176V4.84639Z",
    fill: "#FFBB0B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0019 3.41528H69.2988V4.84639H64.6943V7.04906H68.9379V8.45528H64.6943V10.6953H69.2988V12.1264H63.0019V3.41528Z",
    fill: "#FFBB0B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7434 0.659735L72.5941 0.659668L71.9656 1.28821L74.3719 3.69452V11.847L71.9656 14.2534L72.5941 14.8819H73.7434L76.1497 12.5834V2.95814L73.7434 0.659735Z",
    fill: "#E9AB0C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltimateHover);
export default __webpack_public_path__ + "static/media/ultimate-hover.aa834d80238b73abad8ef7a9f851fb12.svg";
export { ForwardRef as ReactComponent };